import { SalesLead } from '~/models/SalesLead'
import { ApiSalesLead } from './apiTypes'

export class SalesLeadEntityMapper {
	static toSalesLead(apiLead: ApiSalesLead): SalesLead {
		const salesLead: SalesLead = {
			destinationId: apiLead.destination_id,
			userInfo: {},
			tripInfo: {
				minBudget: apiLead.min_budget,
				maxBudget: apiLead.max_budget,
				numTravelers: apiLead.num_travelers,
			},
		}
		return salesLead
	}
}
